<gp-modal #claimModal gp-modal="create-request" [closable]="false" (closed)="onClose()" size="lg">
  <div class="gp-modal-title">
    {{ readOnly ? ('CLAIMS.view_request' | translate) : ('CLAIMS.new_request' | translate) }}
  </div>
  <div class="gp-modal-body clearfix">
    <gp-claim-form [readOnly]="readOnly"
                   [claimForm]="claimForm"
                   [claimTypes]="claimTypes"
                   [cliRegId]="cliRegId"
                   [contractId]="contractId"
                   [selectedClaim]="selectedClaim"
                   [claimTypeTree]="claimTypeTree"
                   [isEss]="true"
                   *ngIf="isModalOpen"
    >
    </gp-claim-form>
  </div>
  <div class="gp-modal-footer">
    <button type="button"
            *ngIf="!readOnly"
            [disabled]="submitting || !claimFormComponent?.isFormValid()"
            class="btn btn-dark p-x-md"
            (click)="onSubmit()">
      {{ 'FORMS.submit' | translate }}
    </button>
    <button type="button"
            class="btn btn-secondary p-x-md"
            (click)="onClose(claimModal)">
      {{ readOnly ? ('FORMS.enclose' | translate) : ('FORMS.cancel' | translate) }}
    </button>
  </div>
</gp-modal>

<div class="box card-box m-x-sm shadow cards-container">

  <div class="box-header">
    <h3>{{'CLAIMS.my_payment_requests' | translate}}</h3>
    <div class="card-dated-controls pull-right no-padding">
      <button type="button"
              class="btn primary add-btn"
              (click)="newClaim()">
        <em class="fa fa-light fa-plus-circle"></em>
        <span class="hidden-sm-down m-l-sm">{{'NOTIFICATIONS.add' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="box-body table-responsive">
    <gp-table class="table">
      <thead gp-table-head>
      <tr role="row">
        <th id="status-indicator" class="hidden-sm-down" gp-table-column></th>
        <th id="claim-type" class="text-center column-title text-muted small" gp-table-column>
          {{ 'COMMON.type' | translate }}
        </th>
        <th id="claim-amount" class="hidden-sm-down text-center column-title text-muted small" gp-table-column>
          {{ 'Amount' | translate }}
        </th>
        <th id="claim-unit" class="hidden-sm-down text-center column-title text-muted small" gp-table-column>
          {{ 'FORMS.Unit' | translate }}
        </th>
        <th id="claim-begin-date" class="text-center column-title text-muted small" gp-table-column>
          {{ 'COMMON.beginDate' | translate }}
        </th>
        <th id="claim-end-date" class="text-center column-title text-muted small" gp-table-column>
          {{ 'COMMON.endDate' | translate }}
        </th>
        <th id="claim-request-date" class="hidden-sm-down text-center column-title text-muted small" gp-table-column>
          {{ 'PAYMENT_REQUEST.date' | translate }}
        </th>
        <th id="claim-status" class="text-center column-title text-muted small" gp-table-column>
          {{ 'COMMON.status' | translate }}
        </th>
        <th id="view-claim" class="hidden-sm-down" gp-table-column></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngIf="loading">
        <td colspan="10" class="text-center p-t-lg p-b-lg">
          <i aria-hidden="true" class="fa fa-light fa-spinner fa-spin"></i>
        </td>
      </tr>
      <tr *ngIf="!loading && (!claims || claims.length===0)">
        <td colspan="10" class="text-center p-t-lg p-b-lg">
          {{ 'CLAIMS.payments_requests_not_found' | translate }}
        </td>
      </tr>
      <tr *ngFor="let claim of claims" (click)="viewClaimOnMobile(claim)">
        <td class="column-status-line hidden-sm-down" [ngClass]="getWorkflowStatus(claim) | lowercase"></td>
        <td class="text-center">{{ claim.transId | translate }}</td>
        <td class="hidden-sm-down text-center">{{ claim.value | gpNumber:'DECIMAL_UP_TO_4_DIGIT' }}</td>
        <td class="hidden-sm-down text-center">{{ getUnitTransId(claim) }}</td>
        <td class="text-center">{{ claim.begindate | gpDate }}</td>
        <td class="text-center">{{ claim.enddate | gpDate }}</td>
        <td class="hidden-sm-down text-center">{{ claim.creationDate | gpDate}}</td>
        <td class="text-center">
          <span [ngSwitch]="getWorkflowStatus(claim)">
          <span *ngSwitchCase="'PENDING'" class="label-gp label-pending">
            <em class="fa fa-light m-r-xs fa-clock"></em><label>{{ 'COMMON.pending' | translate }}</label>
          </span>
          <span *ngSwitchCase="'APPROVED'" class="label-gp label-approved">
            <em class="fa fa-light m-r-xs fa-check-circle"></em><label>{{ 'COMMON.approved' | translate }}</label>
          </span>
          <span *ngSwitchCase="'REJECTED'" class="label-gp label-rejected">
            <em class="fa fa-light m-r-xs fa-times-circle"></em><label>{{ 'COMMON.rejected' | translate }}</label>
          </span>
        </span>
        </td>
        <td class="text-center column-info hidden-sm-down">
          <em class="far fa-eye pointer"
              (click)="viewClaim(claim)">
          </em>
        </td>
      </tr>
      </tbody>
    </gp-table>
  </div>

  <footer class="dker p-a" gp-sticky="bottom">
    <div class="row">
      <div class="col-sm-12 text-center">
        <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
          <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
            <a class="page-link" (click)="pagination.hasPrevious() && pagination.first()"><i
              class="fa fa-light fa-angle-double-left"></i></a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasPrevious()}">
            <a class="page-link" (click)="pagination.hasPrevious() && pagination.previous()"><i
              class="fa fa-light fa-angle-left"></i></a>
          </li>
          <li *ngFor="let page of pagination.pages()" class="page-item"
              [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
            <a *ngIf="page > 0" class="page-link" (click)="pagination.goToPage(page - 1)">{{ page }}</a>
            <a *ngIf="page < 1" class="page-link default-cursor">…</a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
            <a class="page-link" (click)="pagination.hasNext() && pagination.next()"><i
              class="fa fa-light fa-angle-right"></i></a>
          </li>
          <li class="page-item" [ngClass]="{disabled: !pagination.hasNext()}">
            <a class="page-link" (click)="pagination.hasNext() && pagination.last()"><i
              class="fa fa-light fa-angle-double-right"></i></a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</div>
